
import React from 'react';
import { EVALUATION_THEME } from '../evaluationTheme';

const VARIANTS = {
    primary: EVALUATION_THEME.button.primary,
    secondary: "bg-white text-slate-700 border border-slate-300 hover:bg-slate-50",
    success: "bg-emerald-600 text-white hover:bg-emerald-700 border border-emerald-600",
    light: EVALUATION_THEME.button.soft
};

const EvaluationButton = ({
    children,
    onClick,
    type = "button",
    variant = "primary",
    className = "",
    disabled = false
}) => {
    const baseClasses = "rounded-lg font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
    const variantClasses = VARIANTS[variant] || VARIANTS.primary;

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseClasses} ${variantClasses} ${className}`}
        >
            {children}
        </button>
    );
};

export default EvaluationButton;
